/**
 * Creates a CSV File from import data (e.g. CSVBox callback data.rows).
 * Used when CSVBox sends JSON to the client ("Send JSON data to client" option)
 * so we don't need to fetch raw_file (avoids CORS).
 */

function escapeCsvCell(value: unknown): string {
  const s = value === null || value === undefined ? '' : String(value);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/**
 * Builds the CSV string from import records (exported for testing).
 *
 * @param records - Array of record objects from the import
 * @returns CSV string with header line and data lines
 */
export function buildCsvStringFromImportData(
  records: Record<string, unknown>[]
): string {
  if (records.length === 0) return '';
  const headers = Object.keys(records[0] as Record<string, unknown>);
  const headerLine = headers.map(escapeCsvCell).join(',');
  const dataLines = records.map((record) =>
    headers
      .map((h) => escapeCsvCell((record as Record<string, unknown>)[h]))
      .join(',')
  );
  return [headerLine, ...dataLines].join('\r\n');
}

/**
 * @param records - Array of record objects from the import (e.g. CSVBox callback data.rows)
 * @param filename - Filename for the returned File
 * @returns A File with type text/csv
 */
export function createCsvFileFromImportData(
  records: Record<string, unknown>[],
  filename: string
): File {
  const csv = buildCsvStringFromImportData(records);
  const blob = new Blob([csv], { type: 'text/csv' });
  return new File([blob], filename, { type: 'text/csv' });
}
